import React, { Component } from 'react';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { Grid, Button } from '@material-ui/core';
import { useTranslation, Trans } from 'react-i18next';
const { t } = useTranslation();

class Toolbar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: this.props.startDate,
            endDate: this.props.endDate
        };
    }
    
    handleStartDateChange = date => {
        var startdatestringISO = date.toISOString();
        var startdatestring = startdatestringISO.split('T');
        this.setState({
            startDate: startdatestring[0]
        });
    };

    handleEndDateChange = date => {
        var enddatestringISO = date.toISOString();
        var enddatestring = enddatestringISO.split('T');
        this.setState({
            endDate: enddatestring[0]
        });
    };

    handleZoomChange = (e) => {
         if (this.props.onZoomChange) {
             this.props.onZoomChange(e.target.value)
         }
    }

    setNewFilterData = () => {
        this.props.setPlanningSearchDates(this.state.startDate, this.state.endDate);
        this.props.refreshGantt();
    }

    render() {
         const zoomRadios = [{name: <Trans>{t('Hours')}</Trans>, value: 1}, {name: <Trans>{t('Days')}</Trans>, value: 2}, {name: <Trans>{t('Months')}</Trans>, value: 3}].map((value, index, array) => {
             const isActive = this.props.zoom === array[index].value.toString();
             return (
                 <label key={ array[index].value } className={ `radio-label ${isActive ? 'radio-label-active': ''}` }>
                     <input type='radio'
                         checked={ isActive }
                         onChange={ this.handleZoomChange }
                         value={ array[index].value  }/>
                     { array[index].name  }
                 </label>
             );
         });

        return (
            <div className="tool-bar">
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid container spacing={0}>
                        <Grid item xs={7} className="planningToolbarContainer">
                            <b className="greyText">Zooming: </b>
                            { zoomRadios }
                        </Grid>

                        <Grid className="datepicker" item xs={2}>
                            <KeyboardDatePicker
                                disableToolbar
                                variant="inline"
                                format="yyyy-MM-dd"
                                margin="normal"
                                label={<Trans>{t('StartDate')}</Trans>}
                                value={this.state.startDate}
                                onChange={this.handleStartDateChange}
                                KeyboardButtonProps={{
                                    'aria-label': 'change date',
                                }}
                            />
                        </Grid>

                        <Grid className="datepicker" item xs={2}>
                            <KeyboardDatePicker
                                disableToolbar
                                variant="inline"
                                format="yyyy-MM-dd"
                                margin="normal"
                                label={<Trans>{t('EndDate')}</Trans>}
                                value={this.state.endDate}
                                onChange={this.handleEndDateChange}
                                KeyboardButtonProps={{
                                    'aria-label': 'change date',
                                }}
                            />
                        </Grid>

                        <Grid className="pullRight planningToolbarContainer" item xs={1}>
                            <Button className="pullRight" color="secondary" variant="contained" onClick={this.setNewFilterData}>Filter</Button>
                        </Grid>
                    </Grid>   
                </MuiPickersUtilsProvider>
            </div>
        );
    }
}

export default Toolbar;